import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Box, Button, Paper, Stack, Typography } from "@mui/material";

import { Loader } from "../../common/loader";
import TitleCompanyListTable from "./TitleCompanyListTable";
import CustomTabComponent from "../../common/CustomTabComponent";
import AgentsList from "../../attorney-program/Admins/AgentsList";
import AgentOffices from "../../attorney-program/Admins/AgentOffices";
import AdminOverview from "../../attorney-program/Admins/AdminOverview";
import BackArrow from "../../../assets/property-user-list/arrow_back.svg";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";
import SalesRepresentativesTab from "../../attorney-program/Admins/SalesRepresentativesTab";
import { professionalAction } from "../../../redux/slices/admin/professionals/professionalsSlice";

let titleTabContent = [
  {
    label: "Sales Managers",
    optionLabel: "Sales Managers",
    value: 1,
    component: (selectedData) => (
      <AdminOverview
        base_route={selectedData?.source}
        broker_data={selectedData}
        isAgentAdmin={true}
        isSuperAdmin={true}
      />
    ),
  },
  {
    label: "Sales Representatives",
    optionLabel: "Sales Representatives",
    value: 2,
    component: (selectedData) => (
      <SalesRepresentativesTab
        base_route={selectedData?.source}
        broker_data={selectedData}
        isRepInAdmin={true}
        isSuperAdmin={true}
      />
    ),
  },
  {
    label: "Office",
    optionLabel: "Office",
    value: 3,
    component: (selectedData) => (
      <AgentOffices
        base_route={selectedData?.source}
        broker_data={selectedData}
        isAgentAdmin={true}
        isSuperAdmin={true}
      />
    ),
  },
  {
    label: "Real Estate Agents",
    optionLabel: "Real Estate Agents",
    value: 4,
    component: (selectedData) => (
      <AgentsList
        base_route={selectedData?.source}
        broker_data={selectedData}
        isAgentAdmin={true}
        isSuperAdmin={true}
      />
    ),
  },
];
let brokerTabContent = [
  {
    label: "Office",
    optionLabel: "Office",
    value: 1,
    component: (selectedData) => (
      <AgentOffices
        base_route={selectedData?.source}
        broker_data={selectedData}
        isAgentAdmin={true}
        isSuperAdmin={true}
      />
    ),
  },
  {
    label: "Real Estate Agents",
    optionLabel: "Real Estate Agents",
    value: 2,
    component: (selectedData) => (
      <AgentsList
        base_route={selectedData?.source}
        broker_data={selectedData}
        isAgentAdmin={true}
        isSuperAdmin={true}
      />
    ),
  },
];

const TitleCompany = () => {
  const dispatch = useDispatch();

  const [displayRepTable, setDisplayRepTable] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const { titleCompanyLoader } = useSelector((state) => state.professionals);
  const { createAdminLoader, agentAdminLoader, tabValueName } = useSelector(
    (state) => state?.agentsAdmin
  );

  const handleViewRepresentativeBtn = (data) => {
    dispatch(
      agentsAdminAction.getAgentOfficeDetails({
        url: `broker/get-offices?source=${selectedRow?.source}`,
        data: { from_super_admin: true, broker_id: selectedRow?.id },
        token: true,
      })
    );
    dispatch(agentsAdminAction.fetchAgentAdminData({}));
    dispatch(agentsAdminAction.fetchAgentsData({}));
    dispatch(agentsAdminAction.fetchSalesRepresentativeData({}));
    dispatch(
      agentsAdminAction.fetchTabValueName(
        selectedRow?.source === "broker" ? "office" : "Sales Manager"
      )
    );
    dispatch(userProfileAction.setDefaultSelectedTab(1));
    setDisplayRepTable(true);
  };
  const backToBrokerList = (data) => {
    brokersListAPICall();
    setDisplayRepTable(false);
  };
  const brokersListAPICall = () => {
    dispatch(
      professionalAction?.getTitleCompanyListData({
        url: `admin/broker/get-brokers`,
        data: {},
        token: true,
      })
    );
  };
  useEffect(() => {
    brokersListAPICall();
  }, [dispatch]);

  return (
    <Box>
      <Paper
        elevation={0}
        className=" d-flex justify-content-start"
        sx={{ background: "none" }}
      >
        <Box className="view-edit-page" sx={{ mb: 1 }}>
          {displayRepTable && (
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              onClick={backToBrokerList}
            >
              <img
                alt="back arrow"
                src={BackArrow}
                height="12px"
                width="12px"
                className="cursor-pointer"
              />
              <Typography className="back-to-user-list">
                Back to Affiliate Companies
              </Typography>
            </Stack>
          )}
        </Box>
      </Paper>
      <div
        className={`d-flex align-items-center ${
          displayRepTable ? "justify-content-between" : "justify-content-start"
        }`}
      >
        <Typography
          variant="h6"
          className={`card-title fw-600 ${displayRepTable && "mt-3"}`}
        >
          {displayRepTable ? selectedRow?.full_name : "Affiliate Companies"}
        </Typography>
        {displayRepTable && (
          <Button
            variant="contained"
            className="success-btn d-none d-sm-block"
            style={{
              padding: "10px 30px",
              borderRadius: "20px",
            }}
            onClick={() =>
              dispatch(agentsAdminAction.fetchIsAddBtnClicked(true))
            }
          >
            Add {tabValueName}
          </Button>
        )}
      </div>
      {displayRepTable ? (
        <CustomTabComponent
          tabContent={
            selectedRow?.source === "broker"
              ? brokerTabContent
              : titleTabContent
          }
          selectedData={selectedRow}
        />
      ) : (
        <TitleCompanyListTable
          handleViewRepresentativeBtn={handleViewRepresentativeBtn}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          apiCall={brokersListAPICall}
        />
      )}
      <Loader open={titleCompanyLoader} />
      <Loader open={agentAdminLoader || createAdminLoader} />
    </Box>
  );
};

export default TitleCompany;
